import React, { useState } from "react";
import { Toast, ToastContainer, Button } from "react-bootstrap";
import { bookmarkIcon, fileIcon } from "../../constants/icons";
import BookmarkModal from "../modal/BookmarkModal";
import SnackbarDropdown from "../dropdown/SnackbarDropdown";
import RemoveBookmark from "../modal/RemoveBookmark";

const ToastSnackbar = ({
  show,
  onClose,
  papersSelected = 0,
  onClearAll,
  onBookmark,
  onPreviewAndSave,
  loading,
  showModal,
  onModalClose,
  setActiveTab,
  handleSaveCollection,
}) => {

  const [showMultipleBookmarkModal, setShowMultipleBookmarkModal] = useState(false);

  const removeBookClick = () => setShowMultipleBookmarkModal(true);
  const removeBookHandle = () => setShowMultipleBookmarkModal(false);

  return (
    <>
      <ToastContainer position="bottom-center" className="p-4 toast-snackbar">
        <Toast show={show} onClose={onClose} className="bg-dark text-white" autohide delay={9000}>
          <Toast.Body>
            <div className="selection-status">
              {fileIcon}
              <span>{papersSelected} papers selected</span>
            </div>
            <div className="toast-btn-wrap">
              <Button
                variant="link"
                onClick={onClearAll}
                disabled={loading}
              >
                Clear all
              </Button>
              <Button
                variant="outline-light"
                onClick={onBookmark}
                disabled={loading}
              >
                {bookmarkIcon} Bookmark
              </Button>
              <Button variant="outline-light" onClick={onPreviewAndSave}>
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Generating Preview
                  </>
                ) : (
                  <>
                    {fileIcon} Preview &amp; Save
                  </>
                )}
              </Button>
              <SnackbarDropdown removeBookClick={removeBookClick} />
            </div>
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <RemoveBookmark show={showMultipleBookmarkModal} removeBookHandle={removeBookHandle}  title="Are you sure you want to remove the bookmark from these exam papers?" desc="Do you really want to remove this bookmark? This action is irreversible. Proceed with caution." />
      <BookmarkModal showModal={showModal} onModalClose={onModalClose} handleSaveCollection={handleSaveCollection} setActiveTab={setActiveTab} />
    </>
  );
};

export default ToastSnackbar;
